import { createAsyncThunk } from '@reduxjs/toolkit'
import { templatesData } from '@assets/mockdata'
import { Template, UpdateTemplateThunkParams } from '@dataTypes/index'

export const fetchAllTemplates = createAsyncThunk(
  'templates/fetchAllCampaigns',
  async () => {
    return templatesData
  },
)

export const addTemplate = createAsyncThunk(
  'templates/addTemplate',
  async (body: Template) => {
    return body
  },
)

export const updateTemplate = createAsyncThunk(
  'templates/updateTemplate',
  async (params: UpdateTemplateThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeTemplate = createAsyncThunk(
  'templates/removeTemplate',
  async (index: string) => {
    return index
  },
)
